import {COLORS} from 'ac_ui'

function getIconColor(isTaskHeader: boolean): string {
  return isTaskHeader ? COLORS.white : undefined
}

export {getIconColor}
